<div #editorcontainer class="monaco-editor-container pt-1 border-light" (input)="onInputLiveChange($event)">

</div>
